import React from 'react';

import Card from 'components/DesignSystem/Card';
import SubtitleRegular from 'components/Typography/SubtitleRegular';
import DessemSerieChart from 'components/Relatorios/Dessem/DessemSerieChart';
import SecaoDessemEstado from 'components/Relatorios/Dessem/secoes/shared/SecaoDessemEstado';

import useDessemSecaoParams from 'hooks/Relatorios/Dessem/useDessemSecaoParams';
import { useGetDessemGeracaoRenovavelQuery } from 'services/api/products/relatorios';

export default function GeracaoRenovavel() {
  const params = useDessemSecaoParams();

  const resultado = useGetDessemGeracaoRenovavelQuery(params);

  return (
    <SecaoDessemEstado resultado={resultado} params={params}>
      {(data) => (
        <Card title={data.titulo}>
          <SubtitleRegular>{data.fotovoltaica.titulo}</SubtitleRegular>
          <DessemSerieChart
            periodos={data.periodos}
            series={data.fotovoltaica.series}
            nomeEixoY="Geração (MWm)"
            option={data.fotovoltaica.option}
          />

          <SubtitleRegular>{data.eolica.titulo}</SubtitleRegular>
          <DessemSerieChart
            periodos={data.periodos}
            series={data.eolica.series}
            nomeEixoY="Geração (MWm)"
            option={data.eolica.option}
          />
        </Card>
      )}
    </SecaoDessemEstado>
  );
}
